export default "__VITE_ASSET__CNrzBiWf__"